export enum EShownComponent {
  bloczki = 'bloczki',
  map = 'map',
  sort = 'sort',
  filter = 'filter',
}

export type TMainShownComponent = 'bloczki' | 'map';
